var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.currentField.label,"label-width":_vm.currentField.labelWidth + 'px'}},_vm._l((_vm.currentField.options),function(item){return _c('el-radio',{key:item.optionValue,attrs:{"label":item.optionValue,"disabled":item.disabled},model:{value:(_vm.radio),callback:function ($$v) {_vm.radio=$$v},expression:"radio"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }